"use client";
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import logo from './Assets/rentastic.png';


import Header from '../Header';
import Footer from '../Footer';

const Aboutus = () => {
  useEffect(() => {
      window.scrollTo(0, 0);  // ⬅️ Scroll to top when this page mounts
    }, []);
   

  return (
    <div>
     <div className="w-full">
        <Header />
      </div>
    <main className="flex gap-7 p-10 w-full h-auto bg-neutral-50 max-xl:flex-col max-xl:gap-5 max-md:p-5 max-sm:p-4">
      {/* <div className="flex-shrink-0 w-[285px] max-xl:w-full">
        <FilterSidebar />
      </div> */}

      <section className="flex flex-col flex-1 gap-5 min-w-0">
        <div className="bg-gray-50 h-auto pl-6">
      {/* Privacy Policy Heading */}
   <h2
  className="
    text-lg sm:text-xl md:text-xl lg:text-xl
    font-semibold
    text-gray-800
    mb-4 sm:mb-6
    text-center sm:text-left
    pl-0 sm:pl-8 md:pl-10 lg:pl-[36px]
    ml-0 sm:ml-8 md:ml-14
  "
>
        About us
      </h2>

      {/* Card */}
      
        <div className="bg-white rounded-2xl shadow-lg p-8 max-w-5xl mx-auto">
        {/* Logo + Title Centered (side by side) */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <img
            src="https://cdn.acsdev.in/Rentastic/rentastic.png"// replace with your actual logo path
            alt="Rentastic Toys"
            className="w-16 h-16"
          />
          <h2 className="text-2xl font-bold">Rentastic Toys</h2>
        </div>

        {/* Content */}
        <div className="space-y-5 text-gray-700 leading-relaxed">
          <p>
            <strong>1. Rentastic Toys</strong>  is a subscription-based toy rental service delivering high-quality, age-appropriate toys to families across the United States.
          </p>

          <p>
            <strong>2.</strong> We make playtime smarter and more sustainable by giving children access to exceptional toys without the cost and clutter of constant buying.
          </p>

          <p>
            <strong>3. Every toy </strong>is thoroughly cleaned and inspected between rentals to ensure safety and peace of mind.is thoroughly cleaned and inspected between 
            rentals to ensure safety and peace of mind.
          </p>

          <p>
            <strong>4. </strong> With flexible plans and convenient home delivery, parents can choose what’s right for their child  and swap toys as they grow.
          </p>

          <p>
            <strong>5.Less waste. More play. Better value.</strong> 
          </p>

          {/* <p>
            <strong>6. Sustainability </strong> is at the heart of what we do. By promoting toy sharing, 
              we help reduce plastic waste and create a more eco-friendly future for the next generation.
          </p>

          <p>
            <strong>7. </strong> Whether it’s birthdays, weekends, or everyday fun, Rentastic Toys keeps your little ones entertained and learning in the best way possible.
          </p>

          <p>
            <strong>8.</strong> Join our community of smart parents who are redefining playtime — one toy at a time.
          </p> */}
        </div>
      </div>
    </div>

       
      </section>
    </main>
    <div className="w-full">
        <Footer />
      </div>
    </div>
  );
};

export default Aboutus;
